<template id="app-notification">
  <div class="alert-theme" role="alert" v-if="css">
    <div class="notification-bar" :style="{ width: bar + '%' }"></div>
    <div class="alert text-white" :class="css">
      <span v-if="title"><strong>{{ title }}</strong></span>
       <template v-if="text">
          <p class="text-sm" v-for="(value, key) in text" :key="key" v-html="`&bull; ${value}`"></p>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppNotification',
  template: '#app-notification',
  props: {
    title: {
      type: String,
      require: false
    },
    text: {
      type: Array,
      require: false
    },
    css: {
      type: String,
      require: false
    },
    bar: {
      type: Number,
      require: false
    }
  }
}
</script>